module.exports = __webpack_public_path__ + "img/yuan.95f01f44.svg";